<template>
  <div class="header_container">
    <div class="menu-redesign">
      <div class="container" style="display: flex; justify-content: space-between; align-items: center;">
        <router-link class="navbar-brand" to="/" style="margin-left: 0;">
          <img src="@/assets/img/logo_new.svg?v=2" width="116" height="36" alt="Финсайт">
        </router-link>
        <c-menu type="pc" />
        <ul class="header-buttons">
          <li v-if="user === null">
            <router-link to="/login"><img src="@/assets/img/user.svg"></router-link>
          </li>
          <template v-else>
            <li><router-link to="/profile"><img src="@/assets/img/user.svg"></router-link></li>
          </template>
        </ul>
      </div>
    </div>
    <div class="menu_mobile" :class="{ 'no-line': hasHeaderLine }">
      <router-link class="navbar-brand" to="/">
        <img src="@/assets/img/logo_new.svg?v=2" width="116" height="36" alt="Финсайт">
      </router-link>
      <ul>
        <li v-if="user === null">
          <router-link to="/login"><img src="@/assets/img/user.svg"></router-link>
        </li>
        <template v-else>
          <li><router-link to="/profile"><img src="@/assets/img/user.svg"></router-link></li>
        </template>
      </ul>
    </div>

    <div class="mobile" v-if="mobHasMenu">
      <c-menu type="mobile" />
    </div>
  </div>
</template>

<script>
import CMenu from '@/components/newRedesign/UI/MenuNewCopy';

export default {
  name: "Header",
  props: {
    hasHeaderLine: Boolean,
    mobHasMenu: {
      type: Boolean,
      default: true
    },
  },
  data: () => ({
  }),
  components: {
    CMenu,
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
  },
};
</script>
<style scoped></style>
